import { useEffect } from 'react';
import { useBranch, useServices } from '../services';

/**
 * Commands are sent for the branch the person works at, and the server checks that against the
 * run. Opening a run moves the phone to the run's branch when the person may work there, so a
 * driver who covers two branches never sends a delivery for the wrong one.
 */
export function useRunBranch(branchId: string | undefined): { wrongBranch: boolean } {
  const { branch: store } = useServices();
  const branch = useBranch();
  useEffect(() => {
    if (branchId && branch.current !== branchId && branch.options.includes(branchId)) {
      store.select(branchId);
    }
  }, [branchId, branch, store]);
  return {
    wrongBranch: Boolean(branchId) && branch.current !== null && branch.current !== branchId,
  };
}
